import logger from "@insite/client-framework/Logger";
import { ApiParameter, del, get, post, request } from "@insite/client-framework/Services/ApiService";
import {
    Accessorial,
    Accessorials,
    AccessorialState,
    CarrierShipViaAccesorial,
} from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

export interface AddAccessorialApiParameters {
    Master: string;
    Name: string;
    Type: string;
    TI_Code: string;
    TI_Description: string;
    Enabled: boolean;
}

export interface UpdateAccessorialApiParameters extends AddAccessorialApiParameters {
    Id: string;
}

export interface GetAccessioralParam extends ApiParameter {
    shipViaId?: string;
    carrierId?: string;
}

export const getShipViaAccessorials = async (paramaters: GetAccessioralParam) => {
    const response = await get<CarrierShipViaAccesorial>(
        "/api/v2/Accessorials/GetAccessorialsByCarrierAndShipVia",
        paramaters,
    );
    return response;
};

export const getAccessorials = async (paramaters?: any) => {
    const response = await get<AccessorialState>("/api/v2/Accessorials/Get", paramaters);
    return response;
};

export const searchAccessorialsApi = async (parameters: any) => {
    const response = await get<Accessorials>("/api/v2/Accessorials/Search", parameters);
    return response;
};

export const getAccessorialById = async (id: string) => {
    const response = await get<Accessorial>(`/api/v2/Accessorials/${id}`);
    return response;
};

export const addAccessorial = async (parameters: AddAccessorialApiParameters) => {
    const response = await post<AddAccessorialApiParameters>("/api/v2/Accessorials/Create", parameters);
    return response;
};

export const updateAccessorial = async (parameters: UpdateAccessorialApiParameters) => {
    const response = await put<UpdateAccessorialApiParameters>("/api/v2/Accessorials/Update", parameters);
    return response;
};

export const deleteAccessorial = (id: string) => {
    return del(`/api/v2/Accessorials/${id}`);
};

export const uploadAccessorialsApi = async (parameters: any) => {
    const formData = new FormData();
    formData.append("File", parameters.file);
    // const response = await post<any>("/api/v2/Accessorials/Import", formData);
    const response = await request<any>("/api/v2/Accessorials/Import", "POST", {}, formData);
    return response;
};

export const exportAccessorialsApi = async (parameters: string[]) => {
    const response = await post<any>(`/api/v2/Accessorials/Export`, parameters);

    try {
        const blob = response.ok && (await response.blob());
        return blob;
    } catch (error) {
        logger.error(error);
    }
};

// http://localhost:3000/api/v2/Accessorials/Export

function put<T>(endpoint: string, model: Partial<T> | T) {
    return request<T>(endpoint, "PUT", { "Content-Type": "application/json" }, JSON.stringify(model));
}
